export function formatPetsAllowed(petsAllowed: string | string[]) {
    if (petsAllowed === 'true') {
        return 'Pets allowed';
    }

    return '';
}
